import { render, staticRenderFns } from "./kvkkBasvuru.vue?vue&type=template&id=62de3801&scoped=true&"
import script from "./kvkkBasvuru.vue?vue&type=script&lang=js&"
export * from "./kvkkBasvuru.vue?vue&type=script&lang=js&"
import style0 from "./kvkkBasvuru.vue?vue&type=style&index=0&id=62de3801&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de3801",
  null
  
)

export default component.exports